const memberRoutes = [
  {
    path: '/member',
    name: 'Member',
    meta: {
      index: 37
    },
    component: () => import('@/views/member/Index.vue')
  },
  {
    path: '/vip/list',
    name: 'VipList',
    meta: {
      index: 8,
      title: '会员卡'
    },
    component: () => import('@/views/user/vip/Index.vue')
  },
  {
    path: '/vip',
    name: 'QytVip',
    meta: {
      index: 38,
      title: '泉易通会员'
    },
    component: () => import('@/views/vip/Index.vue')
  },
  {
    path: '/member/equity-order',
    name: 'MemberQuityOrder',
    meta: {
      index: 110
    },
    component: () => import('@/views/member/EquityOrder.vue')
  },
  {
    path: '/member/benefit/receive-log',
    name: 'MemberBenefitReceiveLog',
    meta: {
      index: 70
    },
    component: () => import('@/views/member/ReceiveLog')
  },
  {
    path: '/member/equity-order-detail',
    name: 'MemberQuityOrderDetail',
    meta: {
      index: 111
    },
    component: () => import('@/views/member/EquityOrderDetail')
  },
  {
    path: '/member/order-detail',
    name: 'MemberOrderDetail',
    meta: {
      index: 111
    },
    component: () => import('@/views/member/MemberOrderDetail')
  },
  {
    path: '/member/order-return',
    name: 'MemberOrderReturn',
    meta: {
      index: 112
    },
    component: () => import('@/views/member/OrderReturn.vue')
  },
  {
    path: '/member/pay-result',
    name: 'MemberPayResult',
    meta: {
      index: 200
    },
    component: () => import('@/views/member/PayResult.vue')
  },
  {
    path: '/member/h5-pay-result',
    name: 'MemberH5PayResult',
    meta: {
      index: 500
    },
    component: () => import('@/views/member/H5PayResult')
  }
]
export default memberRoutes
